<template lang="pug">
yz-dialog(v-model="showDialog" max-width="480" scrollable, persistent)
  yz-card
    yz-dialog-normal-header(title="Record new payment" @close="showDialog = false")
    .pa-6
      .yz-medium-body-sm.text-neutral-700.mb-3 Select transaction type:
      yz-card.transaction-type-item.pa-4.mb-3(outlined @click="onSelect('payment')")
        .d-flex.align-center
          div
            .yz-medium-body-sm.text-neutral-700 Add payment
            .yz-regular-body-xs.text-neutral-500.mt-1 Record money received from the customer
          v-spacer
          v-icon(color="neutral500" size="20") mdi-chevron-right
      yz-card.transaction-type-item.pa-4(v-if="showRefund" outlined @click="onSelect('refund')")
        .d-flex.align-center
          div
            .yz-medium-body-sm.text-neutral-700 Add refund
            .yz-regular-body-xs.text-neutral-500.mt-1 Record money returned to the customer
          v-spacer
          v-icon(color="neutral500" size="20") mdi-chevron-right
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showRefund: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    showDialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onSelect (type) {
      this.showDialog = false
      this.$emit('select', type)
    }
  }
}
</script>

<style scoped>
.transaction-type-item {
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.transaction-type-item:hover {
  background-color: var(--v-neutral100);
}
</style>
